var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPostImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 115,
    viewBox: "0 0 116 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.0625 23H24.4375C21.5378 23.0035 18.7578 24.1569 16.7074 26.2074C14.6569 28.2578 13.5035 31.0378 13.5 33.9375V82.0625C13.5 88.0913 18.4087 93 24.4375 93H90.0625C96.0913 93 101 88.0913 101 82.0625V33.9375C101 27.9087 96.0913 23 90.0625 23ZM24.4375 31.75H90.0625C90.6427 31.75 91.1991 31.9805 91.6093 32.3907C92.0195 32.8009 92.25 33.3573 92.25 33.9375V64.9956L78.4294 48.8694C77.6986 48.03 76.7975 47.3559 75.7858 46.8919C74.7742 46.428 73.6754 46.1849 72.5625 46.1787C71.4458 46.1845 70.3439 46.4346 69.3342 46.9115C68.3244 47.3885 67.4313 48.0806 66.7175 48.9394L50.4687 68.4431L45.175 63.1625C43.7354 61.7252 41.7843 60.9179 39.75 60.9179C37.7157 60.9179 35.7646 61.7252 34.325 63.1625L22.25 75.2331V33.9375C22.25 33.3573 22.4805 32.8009 22.8907 32.3907C23.3009 31.9805 23.8573 31.75 24.4375 31.75Z",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostImage);
export default __webpack_public_path__ + "static/media/postImage.85c9c0e89f4bafbfc918667ee2d157df.svg";
export { ForwardRef as ReactComponent };